import { LayoutHeader } from '@/components/domains/layouts'
import PolicyBeforePrivacy from '@/components/domains/policy/PolicyBeforePrivacy20220719'

const PagePolicyBeforePrivacy20220719 = () => {
  return (
    <>
      <LayoutHeader />
      <PolicyBeforePrivacy />
    </>
  )
}

export default PagePolicyBeforePrivacy20220719
